import React, { useEffect, useState } from 'react';
import AccountContentContainer from '../AccountContentContainer';
import authTokenUtil from '../authTokenUtil';

const LOADING_WAIT_TIME = 3000;

const ExtensionLoginView = () => {
  const [isFailed, setIsFailed] = useState(false);

  useEffect(() => {
    document.dispatchEvent(
      new CustomEvent('slab-extension.login', {
        detail: authTokenUtil.get(),
      }),
    );

    const timeout = setTimeout(() => {
      setIsFailed(true);
    }, LOADING_WAIT_TIME);

    return () => clearTimeout(timeout);
  }, []);

  return isFailed ? (
    <AccountContentContainer title="Login Failed" />
  ) : (
    <AccountContentContainer
      title="Logging In..."
      subtitle="We're getting everything set up for you."
    />
  );
};

export default ExtensionLoginView;
